export default __webpack_public_path__ + "static/media/starting-reverse.bd1446d1.mp4";